import { render, staticRenderFns } from "./EbookList.vue?vue&type=template&id=8f5f4ab0&scoped=true&"
import script from "./EbookList.vue?vue&type=script&lang=js&"
export * from "./EbookList.vue?vue&type=script&lang=js&"
import style0 from "./EbookList.vue?vue&type=style&index=0&id=8f5f4ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5f4ab0",
  null
  
)

export default component.exports